import request from '../utils/request';
import qs from "qs";

export const getQuotaList = param => {
	return request.get('/api/companyCardQuota/list', { params: param });
};

export const saveQuota = param => {
	return request.post('/api/companyCardQuota/save', qs.stringify(param));
};

export const deleteQuota = param => {
	return request.post('/api/companyCardQuota/delete', qs.stringify(param));
};
